import api from './api';

export const projectService = {
   getAll: async ({ page = 1, limit = 20, status, search } = {}) => {
      const params = { page, limit };
      if (status) params.status = status;
      if (search) params.search = search;
      const response = await api.get('/projects', { params });
      return response.data;
   },

   getById: async (id) => {
      const response = await api.get(`/projects/${id}`);
      return response.data;
   },

   create: async (data) => {
      const response = await api.post('/projects', data);
      return response.data;
   },

   update: async (id, data) => {
      const response = await api.put(`/projects/${id}`, data);
      return response.data;
   },

   delete: async (id) => {
      const response = await api.delete(`/projects/${id}`);
      return response.data;
   },

   uploadLogo: async (file) => {
      const formData = new FormData();
      formData.append('image', file);
      const response = await api.post('/projects/upload-logo', formData, {
         headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
   },
};
